import React from "react";
import { Form } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";
import { useReporterType } from "../../../data/ReporterTypeHook";

function ReporterDetails() {
  const workOrdersRepository = useWorkOrders();
  const reporterTypeRepository = useReporterType();

  const workOrder = workOrdersRepository.getEntry();

  const updateReporterName = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, reportername: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updateReporterType = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, reportertype: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updateReporterEmail = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, reporteremail: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updateReporterTelephone = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, reportertelephone: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updatePoNumber = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, ponumber: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const reporterTypes = reporterTypeRepository.getReporterTypes();

  return (
    <div className="work-order-entry-section reporter-details">
      <h3>Reporter Details</h3>
      <Form.Group className="mb-3" controlId="reporterNameGroup">
        <Form.Label>Reporter</Form.Label>
        <Form.Control
          as="input"
          value={workOrder.reportername}
          onChange={updateReporterName}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="reporterTypeGroup">
        <Form.Label>Reporter Type</Form.Label>
        <Form.Select
          value={workOrder.reportertype}
          onChange={updateReporterType}
        >
          {reporterTypes.map((nextType) => (
            <option key={nextType.id} value={nextType.id}>
              {nextType.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3" controlId="reporterEmailGroup">
        <Form.Label>Reporter Email</Form.Label>
        <Form.Control
          as="input"
          type="email"
          value={workOrder.reporteremail}
          onChange={updateReporterEmail}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="reporterTelephoneGroup">
        <Form.Label>Reporter Telephone</Form.Label>
        <Form.Control
          as="input"
          value={workOrder.reportertelephone}
          onChange={updateReporterTelephone}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="poNumberGroup">
        <Form.Label>PO Number</Form.Label>
        <Form.Control
          as="input"
          value={workOrder.ponumber}
          onChange={updatePoNumber}
        />
      </Form.Group>
    </div>
  );
}

export default ReporterDetails;
